import { Component, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';

import { Subscription } from 'rxjs';

import { SharedService } from '@services/shared.service';
import { Router } from '@angular/router';


@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnDestroy {

    private titleSubscription: Subscription = null;
    private backSubscription: Subscription = null;
    private mainBackSubscription: Subscription = null;
    private logoutSubscription: Subscription = null;

    pageTitle: string;

    showPageBack = false;
    showMainPageBack = false;

    constructor(
        public location: Location,
        private router: Router,
        public sharedService: SharedService
    ) {

        const urls = this.router.url.split('/').filter(x => x);
        const baseUrl = urls.length ? `/${urls.shift()}` : '';

        // Set page title from state manual
        this.titleSubscription = this.sharedService.pageTitleSubject.subscribe(
            (title: string) => {
                this.pageTitle = title;
            }
        );

        // subscribe the company changes
        this.backSubscription = this.sharedService.pageBackSubject.subscribe(
            (show: boolean) => {

                // this.showMainPageBack = !show;
                this.showPageBack = show;
            }
        );

        // Back a market
        this.mainBackSubscription = this.sharedService.mainPageBackSubject.subscribe(
            (show: boolean) => {

                this.showMainPageBack = show;
                // this.showPageBack = !show;
            }
        );

        // subscribe and tracking the logout state
        this.logoutSubscription = this.sharedService.logoutSubject.subscribe(() => {

            this.pageTitle = null;
        });
    }

    ngOnDestroy() {

        if (this.titleSubscription) { this.titleSubscription.unsubscribe(); }

        if (this.backSubscription) { this.backSubscription.unsubscribe(); }

        if (this.logoutSubscription) { this.logoutSubscription.unsubscribe(); }

        if (this.mainBackSubscription) { this.mainBackSubscription.unsubscribe(); }
    }


    onBack() {

        const path = this.location.path();
        if (path.indexOf('givi')) {

        }
        this.location.back();
    }

    onMainBack() {
        this.router.navigate(['/market'], { queryParams: { login: 'success' } });
    }
}
